export const CUSTOM_ICONS: { name: string; src: string }[] = [
  {
    name: 'supervised-user-circle',
    src: 'assets/supervised-user-circle.svg',
  },
  {
    name: 'supervised-user-circle-filled',
    src: 'assets/supervised-user-circle-filled.svg',
  },
  {
    name: 'sensor-occupied',
    src: 'assets/sensor-occupied.svg',
  },
  {
    name: 'shield-key',
    src: 'assets/shield-key.svg',
  },
  {
    name: 'replace-placeholder',
    src: 'assets/editor/placeholder/add-chart.svg',
  },
  {
    name: 'adjust',
    src: 'assets/adjust.svg',
  },
  {
    name: 'arrow-back',
    src: 'assets/arrow_back.svg',
  },
  {
    name: 'arrow-forward',
    src: 'assets/arrow_forward.svg',
  },
  {
    name: 'arrow_drop_down',
    src: 'assets/arrow_drop_down.svg',
  },
  {
    name: 'data-tips',
    src: 'assets/data-tips.svg',
  },
  {
    name: 'trash',
    src: 'assets/editor/action-bar/trash.svg',
  },
  {
    name: 'grey-trash',
    src: 'assets/editor/action-bar/grey-trash.svg',
  },
  {
    name: 'duplicate',
    src: 'assets/editor/action-bar/duplicate.svg',
  },
  {
    name: 'group-objects',
    src: 'assets/editor/floating-panel/group-objects.svg',
  },
  {
    name: 'group-objects-dark',
    src: 'assets/editor/action-bar/group-objects.svg',
  },
  {
    name: 'ungroup-objects',
    src: 'assets/editor/action-bar/ungroup-objects.svg',
  },
  {
    name: 'lock',
    src: 'assets/editor/action-bar/lock.svg',
  },
  {
    name: 'lock-open',
    src: 'assets/editor/action-bar/lock-open.svg',
  },
  {
    name: 'ungroup-objects-dark',
    src: 'assets/editor/action-bar/ungroup-objects.svg',
  },
  {
    name: 'bring-to-top',
    src: 'assets/editor/action-bar/bring-to-top.svg',
  },
  {
    name: 'move-backward',
    src: 'assets/editor/action-bar/move-backward.svg',
  },
  {
    name: 'move-forward',
    src: 'assets/editor/action-bar/move-forward.svg',
  },
  {
    name: 'send-to-back',
    src: 'assets/editor/action-bar/send-to-back.svg',
  },
  {
    name: 'align-to-left',
    src: 'assets/editor/action-bar/align-to-left.svg',
  },
  {
    name: 'align-to-right',
    src: 'assets/editor/action-bar/align-to-right.svg',
  },
  {
    name: 'align-to-bottom',
    src: 'assets/editor/action-bar/align-to-bottom.svg',
  },
  {
    name: 'align-to-top',
    src: 'assets/editor/action-bar/align-to-top.svg',
  },
  {
    name: 'align-horizontally',
    src: 'assets/editor/action-bar/align-horizontally.svg',
  },
  {
    name: 'align-vertically',
    src: 'assets/editor/action-bar/align-vertically.svg',
  },
  {
    name: 'align-spaces-horizontally',
    src: 'assets/editor/action-bar/align-spaces-horizontally.svg',
  },
  {
    name: 'align-spaces-vertically',
    src: 'assets/editor/action-bar/align-spaces-vertically.svg',
  },
  {
    name: 'label-outline',
    src: 'assets/data-model/label-outline.svg',
  },
  {
    name: 'join-equal',
    src: 'assets/data-model/join-equal.svg',
  },
  {
    name: 'key-field',
    src: 'assets/data-model/key-field.svg',
  },
  {
    name: 'outer-join',
    src: 'assets/data-model/outer-join.svg',
  },
  {
    name: 'outer-join-red',
    src: 'assets/data-model/outer-join-red.svg',
  },
  {
    name: 'dismiss-join',
    src: 'assets/data-model/dismiss-join.svg',
  },
  {
    name: 'key',
    src: 'assets/data-model/key.svg',
  },
  {
    name: 'data-type-boolean',
    src: 'assets/data-model/data-type/boolean.svg',
  },
  {
    name: 'data-type-date',
    src: 'assets/data-model/data-type/date.svg',
  },
  {
    name: 'data-type-decimal',
    src: 'assets/data-model/data-type/decimal.svg',
  },
  {
    name: 'data-type-float',
    src: 'assets/data-model/data-type/float.svg',
  },
  {
    name: 'data-type-int',
    src: 'assets/data-model/data-type/int.svg',
  },
  {
    name: 'data-type-json',
    src: 'assets/data-model/data-type/json.svg',
  },
  {
    name: 'data-type-string',
    src: 'assets/data-model/data-type/string.svg',
  },
  {
    name: 'data-type-time',
    src: 'assets/data-model/data-type/time.svg',
  },
  {
    name: 'data-type-timestamp',
    src: 'assets/data-model/data-type/timestamp.svg',
  },
  {
    name: 'data-type-timestamp_tz',
    src: 'assets/data-model/data-type/timestamp-tz.svg',
  },
  {
    name: 'data-type-number',
    src: 'assets/data-model/data-type/int.svg',
  },
  {
    name: 'data-type-millisec',
    src: 'assets/data-model/data-type/int.svg',
  },
  {
    name: 'data-type-calculation',
    src: 'assets/data-model/data-type/calculated.svg',
  },
  {
    name: 'data-type-unhandled',
    src: 'assets/data-model/data-type/unhandled.svg',
  },
  {
    name: 'data-view-data-source',
    src: 'assets/data-model/data-source.svg',
  },
  {
    name: 'data-view-data-model',
    src: 'assets/data-model/data-model.svg',
  },
  {
    name: 'view-module',
    src: 'assets/data-model/joins/view-module.svg',
  },
  {
    name: 'view-column',
    src: 'assets/data-model/joins/view-column.svg',
  },
  {
    name: 'directed-join',
    src: 'assets/data-model/joins/directed-join.svg',
  },
  {
    name: 'union',
    src: 'assets/data-model/joins/union.svg',
  },
  {
    name: 'data-source-type-table',
    src: 'assets/data-model/source-type/table.svg',
  },
  {
    name: 'data-source-type-view',
    src: 'assets/data-model/source-type/view.svg',
  },
  {
    name: 'data-source-type-materialized-view',
    src: 'assets/data-model/source-type/materialized-view.svg',
  },
  {
    name: 'data-source-type-streaming-table',
    src: 'assets/data-model/source-type/streaming-table.svg',
  },
  {
    name: 'data-source-type-statement',
    src: 'assets/data-model/source-type/sql.svg',
  },
  {
    name: 'data-source-type-csv',
    src: 'assets/data-model/source-type/csv.svg',
  },
  {
    name: 'data-source-type-excel',
    src: 'assets/data-model/source-type/excel.svg',
  },
  {
    name: 'data-source-type-inline',
    src: 'assets/data-model/source-type/inline.svg',
  },
  {
    name: 'data-view-locale',
    src: 'assets/data-model/locale.svg',
  },
  {
    name: 'add-button',
    src: 'assets/data-model/custom-data-creator/add-button.svg',
  },
  {
    name: 'saml-connection',
    src: 'assets/administration/enterprise/saml-connection.svg',
  },
  {
    name: 'oidc-connection',
    src: 'assets/administration/enterprise/oidc-connection.svg',
  },
  {
    name: 'google-bigquery-connection',
    src: 'assets/administration/enterprise/google-bigquery-connection.svg',
  },
  {
    name: 'snowflake-connection',
    src: 'assets/administration/enterprise/snowflake-connection.svg',
  },
  {
    name: 'azure-snowflake-connection',
    src: 'assets/administration/enterprise/azure-snowflake-connection.svg',
  },
  {
    name: 'google-apps-connection',
    src: 'assets/administration/enterprise/google-apps-connection.svg',
  },
  {
    name: 'ping-connection',
    src: 'assets/administration/enterprise/ping-connection.svg',
  },
  {
    name: 'keycloak-connection',
    src: 'assets/administration/enterprise/keycloak-connection.svg',
  },
  {
    name: 'azure-ad-connection',
    src: 'assets/administration/enterprise/azure-ad-connection.svg',
  },
  {
    name: 'ad-ldap-connection',
    src: 'assets/administration/enterprise/ad-ldap-connection.svg',
  },
  {
    name: 'okta-connection',
    src: 'assets/administration/enterprise/okta-connection.svg',
  },
  {
    name: 'cognito-connection',
    src: 'assets/administration/enterprise/cognito-connection.svg',
  },
  {
    name: 'databricks-connection',
    src: 'assets/administration/enterprise/databricks-connection.svg',
  },
  {
    name: 'link',
    src: 'assets/editor/visualization/link.svg',
  },
  {
    name: 'copy-link',
    src: 'assets/administration/embed/copy-link.svg',
  },
  {
    name: 'copy-code',
    src: 'assets/administration/embed/copy-code.svg',
  },
  {
    name: 'warning-circle',
    src: 'assets/administration/warning-circle.svg',
  },
  {
    name: 'info-circle',
    src: 'assets/administration/info-circle.svg',
  },
  {
    name: 'copy',
    src: 'assets/editor/context-menu/copy.svg',
  },
  {
    name: 'paste',
    src: 'assets/editor/context-menu/paste.svg',
  },
  {
    name: 'keyboard-outline',
    src: 'assets/editor/actions/keyboard-outline.svg',
  },
  {
    name: 'cut',
    src: 'assets/editor/context-menu/cut.svg',
  },
  {
    name: 'info',
    src: 'assets/editor/context-menu/info.svg',
  },
  {
    name: 'show-in-layers',
    src: 'assets/editor/context-menu/show-in-layers.svg',
  },
  {
    name: 'export',
    src: 'assets/editor/context-menu/export.svg',
  },
  {
    name: 'arrange',
    src: 'assets/editor/context-menu/arrange.svg',
  },
  {
    name: 'sheets',
    src: 'assets/editor/toolbar/sheets.svg',
  },
  {
    name: 'charts',
    src: 'assets/editor/toolbar/charts.svg',
  },
  {
    name: 'filters',
    src: 'assets/editor/toolbar/filters.svg',
  },
  {
    name: 'controls',
    src: 'assets/editor/toolbar/control.svg',
  },
  {
    name: 'bar-chart',
    src: 'assets/editor/visualization/bar-chart.svg',
  },
  {
    name: 'calendar',
    src: 'assets/editor/control/calendar.svg',
  },
  {
    name: 'combo-chart',
    src: 'assets/editor/visualization/combo-chart.svg',
  },
  {
    name: 'gauge-chart',
    src: 'assets/editor/visualization/gauge-chart.svg',
  },
  {
    name: 'heat-map-chart',
    src: 'assets/editor/visualization/heat-map-chart.svg',
  },
  {
    name: 'image',
    src: 'assets/editor/visualization/image.svg',
  },
  {
    name: 'line-chart',
    src: 'assets/editor/visualization/line-chart.svg',
  },
  {
    name: 'number',
    src: 'assets/editor/visualization/number.svg',
  },
  {
    name: 'pie-chart',
    src: 'assets/editor/visualization/pie-chart.svg',
  },
  {
    name: 'objects-insights',
    src: 'assets/editor/visualization/objects-insights.svg',
  },
  {
    name: 'scatter-chart',
    src: 'assets/editor/visualization/scatter-chart.svg',
  },
  {
    name: 'table',
    src: 'assets/editor/visualization/table.svg',
  },
  {
    name: 'histogram',
    src: 'assets/editor/visualization/histogram-column.svg',
  },
  {
    name: 'text-object',
    src: 'assets/editor/visualization/text.svg',
  },
  {
    name: 'objects-date-picker',
    src: 'assets/editor/control/calendar.svg',
  },
  {
    name: 'shape',
    src: 'assets/editor/visualization/shape.svg',
  },
  {
    name: 'distribution-gauge-chart',
    src: 'assets/editor/visualization/distribution-gauge-chart.svg',
  },
  {
    name: 'filter',
    src: 'assets/editor/visualization/filter.svg',
  },
  {
    name: 'input-box',
    src: 'assets/editor/visualization/input-box.svg',
  },
  {
    name: 'simple-text-object',
    src: 'assets/editor/visualization/text.svg',
  },
  {
    name: 'astrato-filter-pane',
    src: 'assets/editor/visualization/filter.svg',
  },
  {
    name: 'slider-filter',
    src: 'assets/editor/control/slider.svg',
  },
  {
    name: 'slider',
    src: 'assets/editor/control/slider.svg',
  },
  {
    name: 'toggle',
    src: 'assets/editor/control/toggle.svg',
  },
  {
    name: 'atomic-input',
    src: 'assets/editor/control/atomic-input.svg',
  },
  {
    name: 'grey-variable',
    src: 'assets/editor/visualization/grey-variable.svg',
  },
  {
    name: 'variable-type-string',
    src: 'assets/editor/variables/string.svg',
  },
  {
    name: 'variable-type-string-sql',
    src: 'assets/editor/variables/string-sql.svg',
  },
  {
    name: 'variable-type-boolean',
    src: 'assets/editor/variables/boolean.svg',
  },
  {
    name: 'variable-type-number',
    src: 'assets/editor/variables/number.svg',
  },
  {
    name: 'button',
    src: 'assets/editor/control/button.svg',
  },
  {
    name: 'dev-button',
    src: 'assets/editor/control/button.svg',
  },
  {
    name: 'upload-media',
    src: 'assets/media-gallery/files-icon.svg',
  },
  {
    name: 'no-report-created',
    src: 'assets/workbooks/no-report-created.svg',
  },
  //
  // WARNING below are dedicated for Auth Login
  //
  {
    name: 'google',
    src: 'assets/icons/google.svg',
  },
  {
    name: 'linkedin',
    src: 'assets/icons/linkedin.svg',
  },
  {
    name: 'oidc',
    src: 'assets/icons/oidc-connection.svg',
  },
  {
    name: 'state-off',
    src: 'assets/state-off.svg',
  },
  {
    name: 'view',
    src: 'assets/workbooks/view.svg',
  },
  {
    name: 'sheet',
    src: 'assets/editor/visualization/sheet.svg',
  },
  {
    name: 'layers',
    src: 'assets/editor/visualization/layers.svg',
  },
  {
    name: 'snowflake',
    src: 'assets/datasources/snowflake.svg',
  },
  {
    name: 'dremio',
    src: 'assets/datasources/dremio.svg',
  },
  {
    name: 'gsheet',
    src: 'assets/datasources/gsheet.svg',
  },
  {
    name: 'postgres',
    src: 'assets/datasources/postgres.svg',
  },
  {
    name: 'supabase',
    src: 'assets/datasources/supabase.svg',
  },
  {
    name: 'redshift',
    src: 'assets/datasources/redshift.svg',
  },
  {
    name: 'databricks',
    src: 'assets/datasources/databricks.svg',
  },
  {
    name: 'google_bigquery',
    src: '/assets/google_bigquery.svg',
  },
  {
    name: 'duckdb',
    src: '/assets/datasources/duckdb.svg',
  },
  {
    name: 'athena',
    src: '/assets/datasources/athena.svg',
  },
  {
    name: 'demo',
    src: 'assets/datasources/demo.svg',
  },
  {
    name: 'manual_data',
    src: 'assets/editor/manual-data.svg',
  },
  {
    name: 'select-arrow',
    src: 'assets/form-icons/select-arrow.svg',
  },
  {
    name: 'calculate-icon',
    src: 'assets/data-model/calculate-icon.svg',
  },
  {
    name: 'operator-divide',
    src: 'assets/operators/operator-divide.svg',
  },
  {
    name: 'operator-minus',
    src: 'assets/operators/operator-minus.svg',
  },
  {
    name: 'operator-multiple',
    src: 'assets/operators/operator-multiple.svg',
  },
  {
    name: 'operator-plus',
    src: 'assets/operators/operator-plus.svg',
  },
  {
    name: 'drag-handle',
    src: 'assets/drag-handle.svg',
  },
  {
    name: 'invite-people',
    src: 'assets/collections/invite-people.svg',
  },
  {
    name: 'remove_circle_outline',
    src: 'assets/administration/people/remove_circle_outline.svg',
  },
  {
    name: 'show-hide-object',
    src: 'assets/workbooks/show-hide-object.svg',
  },
  {
    name: 'ai-generate-title',
    src: 'assets/workbooks/ai-generate-title.svg',
  },
  {
    name: 'sort-default',
    src: 'assets/sort.svg',
  },
  {
    name: 'sort-asc',
    src: 'assets/sort_asc.svg',
  },
  {
    name: 'sort-desc',
    src: 'assets/sort_desc.svg',
  },
  {
    name: 'type-selector',
    src: 'assets/data-model/custom-fields/type-selector.svg',
  },
  {
    name: 'drag-handle-2',
    src: 'assets/drag-handle-2.svg',
  },
  {
    name: 'green-check-circle',
    src: 'assets/check_circle.svg',
  },
  {
    name: 'green-sign-circle',
    src: 'assets/circle_sign_green.svg',
  },
  {
    name: 'red-sign-circle',
    src: 'assets/circle_sign_red.svg',
  },
  {
    name: 'red-warning',
    src: 'assets/red-warning.svg',
  },
  {
    name: 'orange-warning',
    src: 'assets/orange-warning.svg',
  },
  {
    name: 'equals',
    src: 'assets/data-model/filter/equals.svg',
  },
  {
    name: 'not-equals',
    src: 'assets/data-model/filter/not-equals.svg',
  },
  {
    name: 'greater',
    src: 'assets/data-model/filter/greater.svg',
  },
  {
    name: 'greater-or-equal',
    src: 'assets/data-model/filter/greater-or-equal.svg',
  },
  {
    name: 'less',
    src: 'assets/data-model/filter/less.svg',
  },
  {
    name: 'less-or-equal',
    src: 'assets/data-model/filter/less-or-equal.svg',
  },
  {
    name: 'between',
    src: 'assets/data-model/filter/between.svg',
  },
  {
    name: 'not-between',
    src: 'assets/data-model/filter/not-between.svg',
  },
  {
    name: 'contains',
    src: 'assets/data-model/filter/contains.svg',
  },
  {
    name: 'not-contains',
    src: 'assets/data-model/filter/not-contains.svg',
  },
  {
    name: 'like',
    src: 'assets/data-model/filter/like.svg',
  },
  {
    name: 'not-like',
    src: 'assets/data-model/filter/not-like.svg',
  },
  {
    name: 'in-list',
    src: 'assets/data-model/filter/in-list.svg',
  },
  {
    name: 'not-in-list',
    src: 'assets/data-model/filter/not-in-list.svg',
  },
  {
    name: 'not-set',
    src: 'assets/data-model/filter/not-set.svg',
  },
  {
    name: 'set',
    src: 'assets/data-model/filter/set.svg',
  },
  {
    name: 'predefined-period',
    src: 'assets/data-model/filter/predefined-period.svg',
  },
  {
    name: 'self-service',
    src: 'assets/editor/visualization/self-service.svg',
  },
  {
    name: 'line-bezier',
    src: 'assets/data-model/line-types/bezier.svg',
  },
  {
    name: 'line-flow-chart',
    src: 'assets/data-model/line-types/flow-chart.svg',
  },
  {
    name: 'line-straight',
    src: 'assets/data-model/line-types/straight.svg',
  },
  {
    name: 'line-stub',
    src: 'assets/data-model/line-types/stub.svg',
  },
  {
    name: 'add_circle',
    src: 'assets/data-model/add_circle.svg',
  },
  {
    name: 'switch-on',
    src: 'assets/data-model/suggested-joins/switch-on.svg',
  },
  {
    name: 'switch-off',
    src: 'assets/data-model/suggested-joins/switch-off.svg',
  },
  {
    name: 'model-reset',
    src: 'assets/data-model/model-reset.svg',
  },
  {
    name: 'more',
    src: 'assets/more.svg',
  },
  {
    name: 'dimension-drill-down',
    src: 'assets/data-model/dimension-types/dimension-drill-down.svg',
  },

  {
    name: 'dimension-drill-through',
    src: 'assets/data-model/dimension-types/dimension-drill-through.svg',
  },
  {
    name: 'dimension-drill-grouped',
    src: 'assets/data-model/dimension-types/dimension-grouped.svg',
  },
  {
    name: 'dimension-bucket',
    src: 'assets/data-model/dimension-types/dimension-bucket.svg',
  },
  {
    name: 'compare-arrows',
    src: 'assets/data-model/compare-arrows.svg',
  },
  {
    name: 'picture_as_pdf',
    src: 'assets/navigation/picture_as_pdf.svg',
  },
  {
    name: 'gen-ai',
    src: 'assets/gen-ai.svg',
  },
  {
    name: 'excel_icon',
    src: 'assets/excel_icon.svg',
  },
  {
    name: 'csv_icon',
    src: 'assets/csv_icon.svg',
  },
  {
    name: 'expand_icon',
    src: 'assets/expand_icon.svg',
  },
  {
    name: 'clickhouse',
    src: 'assets/datasources/clickhouse.svg',
  },
  {
    name: 'calendar',
    src: '/assets/calendar.svg',
  },
  {
    name: 'disabled-sheet',
    src: 'assets/workbooks/disabled-sheet.svg',
  },
  {
    name: 'copy_object',
    src: 'assets/editor/context-menu/copy-object.svg',
  },
];
